<template>
    <div class="home_kh_box">
        <HeaderNav
            header-title="砼享云供应商端"
            left-icon-name="1"
            right-icon-name="1"
        ></HeaderNav>
        <div class="header-box">
            <img src="@/assets/images/home_sj/bannner.jpg" alt="">
        </div>
        <div class="home-content">
            <div class="item color1" @click="btnClick('orderTakingList')">
                <div class="info">
                    <div class="split-icon">
                        <i></i>
                    </div>
                    <div class="tit">
                        <h4>供应单接收</h4>
                        <p>
                            此处为供应单接收简单介绍
                        </p>
                    </div>
                </div>
                <div class="img-con">
                    <img src="@/assets/images/home_gys/message.png">
                </div>
            </div>
            <div class="item color2" @click="btnClick('FeedbackList')">
                <div class="info">
                    <div class="split-icon">
                        <i></i>
                    </div>
                    <div class="tit">
                        <h4>供应单反馈</h4>
                        <p>
                            此处为供应单反馈简单介绍
                        </p>
                    </div>
                </div>
                <div class="img-con">
                    <img src="../../assets/images/home_kh/evaluate_home.png">
                </div>
            </div>
            <div class="item color3" @click="btnClick('affirmList')">
                <div class="info">
                    <div class="split-icon">
                        <i></i>
                    </div>
                    <div class="tit">
                        <h4>供应单确认</h4>
                        <p>
                            此处为供应单确认简单介绍
                        </p>
                    </div>
                </div>
                <div class="img-con">
                    <img src="../../assets/images/home_kh/materials_home.png">
                </div>
            </div>
            <div class="item color5" @click="btnClick('priceChange')">
                <div class="info">
                    <div class="split-icon">
                        <i></i>
                    </div>
                    <div class="tit">
                        <h4>价格变更</h4>
                        <p>
                            此处为价格变更简单介绍
                        </p>
                    </div>
                </div>
                <div class="img-con">
                    <img src="../../assets/images/home_kh/statistics_home.png">
                </div>
            </div>
            <div class="item color4" @click="btnClick()">
                <div class="info">
                    <div class="split-icon">
                        <i></i>
                    </div>
                    <div class="tit">
                        <h4>结算对账</h4>
                        <p>
                            此处为结算对账简单介绍
                        </p>
                    </div>
                </div>
                <div class="img-con">
                    <img src="../../assets/images/home_kh/account_home.png">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
import { Toast } from 'vant';
export default {
    data() {
        return {
            homeData: [],
        };
    },
    components: {
        HeaderNav,
    },
    mounted() {

    },
    methods: {
        btnClick(name) {
            if (name) {
                this.$router.isBack = 2;
                this.$router.push({ name: name, params: { } });
            } else {
                Toast({
                    message: '正在开发中……',
                    icon: 'info',
                });
            }

        },
    },
};

</script>
<style lang='stylus'>
.home_kh_box
    height 100%
    padding-top 44rpx
    .header-box
        width 100%
        height 184rpx
        img
            width 100%
            height 100%
    .home-content
        background #F0F0F0
        overflow hidden
        height calc(100% - 184rpx)
        .item
            width calc(50% - 15rpx);
            height 87rpx;
            background rgba(255,255,255,1)
            box-shadow 0px 2px 8px 0px rgba(0, 0, 0, 0.1)
            float left
            margin 10rpx 10rpx 0 10rpx
            padding 10rpx 0 10rpx 10rpx
            &:nth-child(1n)
                margin-right 0
            .info
                float left
                width calc(100% - 55rpx)
                height 100%
                .split-icon
                    width 3rpx
                    height 100%
                    float left
                    i
                        width 3rpx
                        height 13rpx
                        background #3595FA
                        display inline-block
                        margin-top 9rpx
                .tit
                    width calc(100% - 3rpx)
                    height 100%
                    float left
                    padding-left 10rpx
                    h4
                        font-size 14rpx
                        margin 5rpx 0
                        font-weight 800
                    p
                        font-size 10rpx
                        color #979EA7
            .img-con
                float left
                width 55rpx
                height 55rpx
                img
                    width 100%
                    height 100%
            &.color1
                .split-icon
                    i
                        background #3595FA
            &.color2
                .split-icon
                    i
                        background #FEAB06
            &.color3
                .split-icon
                    i
                        background #FF6600
            &.color4
                .split-icon
                    i
                        background #16BC84
</style>
